<template>
  <v-app>
    <v-container fluid style="max-width: 1200px">
      <div class="mb-5">
        <h1>Validate Files before upload</h1>
      </div>

      <v-tabs v-model="activeTab" class="mb-4">
        <v-tab>Multi File Upload</v-tab>
        <v-tab>Single File Upload</v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <multi-file-upload />
        </v-tab-item>
        <v-tab-item>
          <upload-files />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-app>
</template>

<script>
import UploadFiles from '../components/UploadFiles';
import MultiFileUpload from '../components/MultiFileUpload';

export default {
  name: 'App',
  components: {
    UploadFiles,
    MultiFileUpload,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>
